/* KORE Benefits — «Un modelo que suma al club»
   (sections/kore-benefits.liquid).

   La entrada de las tarjetas es de assets/kore-stage3d.js. Aquí:
   - cada tarjeta se inclina hacia el puntero y su brillo lo sigue;
   - la curva del beneficio del club, en directo (ingresos());
   - la banda «Sin carga operativa» tiene su propia entrada, porque está
     más abajo: las tareas salen del club y aterrizan en KORE cuando la
     banda entra en pantalla, no cuando entran las tarjetas.

   Sin JS o con movimiento reducido no se arma nada: las tareas ya están
   en KORE y las tarjetas, quietas. */
(function () {
  'use strict';
  if (window.KoreBenefits) return;
  window.KoreBenefits = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var bandas = [];
  var raf = 0;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function tarjeta(card) {
    if (card.getAttribute('data-kb-ok')) return;
    card.setAttribute('data-kb-ok', '1');
    var rafT = 0, ev = null;
    function pintar() {
      rafT = 0;
      if (!ev) return;
      var r = card.getBoundingClientRect();
      var x = clamp((ev.clientX - r.left) / r.width, 0, 1);
      var y = clamp((ev.clientY - r.top) / r.height, 0, 1);
      card.style.setProperty('--ry', ((x - 0.5) * 9).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
      card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
    }
    card.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      card.classList.add('is-hover');
    });
    card.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      ev = e;
      if (!rafT) rafT = requestAnimationFrame(pintar);
    });
    card.addEventListener('pointerleave', function () {
      ev = null;
      card.classList.remove('is-hover');
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    });
  }

  /* ── La curva del beneficio, en directo ──
     Cada venta es una prenda que cae sobre la curva: al tocarla, el
     beneficio del club sube un peldaño. Al llegar arriba se queda un
     momento, se apaga y vuelve a empezar. Solo corre con la tarjeta en
     pantalla y la pestaña visible. Sin cifras: la forma lo dice todo. */
  var VENTAS = [[.1, .78], [.2, .7], [.31, .6], [.42, .53], [.52, .42], [.63, .34], [.74, .22], [.86, .12]];
  var X0 = 0.02, BASE = 0.9, XFIN = 0.98, RAMPA = 6;

  function ingresos(root) {
    var graf = root.querySelector('[data-kb-graf]');
    if (!graf || reduce.matches || graf.getAttribute('data-kb-ok')) return;
    graf.setAttribute('data-kb-ok', '1');
    var svg = graf.querySelector('svg');
    var linea = graf.querySelector('.kb__ing-linea');
    var area = graf.querySelector('.kb__ing-area');
    var inv = graf.querySelector('.kb__ing-inv');
    var head = graf.querySelector('.kb__ing-head');
    var toks = Array.prototype.slice.call(graf.querySelectorAll('[data-kb-tok]'));
    var card = root.querySelector('[data-kb-card]') || graf;
    var n = VENTAS.length;
    var st = { k: n, w: 0, h: 0, L: [], P: [], total: 0, timer: 0, cuenta: 0 };

    function medir() {
      var w = graf.clientWidth, h = graf.clientHeight;
      if (!w || !h || (w === st.w && h === st.h)) return;
      st.w = w; st.h = h;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      var x = X0 * w, y = BASE * h, len = 0;
      var d = 'M' + x.toFixed(1) + ' ' + y.toFixed(1);
      st.L = [0]; st.P = [[x, y]];
      VENTAS.forEach(function (v) {
        var px = v[0] * w, py = v[1] * h, hx = px - RAMPA;
        len += (hx - x) + Math.sqrt(RAMPA * RAMPA + (py - y) * (py - y));
        d += ' H' + hx.toFixed(1) + ' L' + px.toFixed(1) + ' ' + py.toFixed(1);
        x = px; y = py;
        st.L.push(len); st.P.push([px, py]);
      });
      var xe = XFIN * w;
      len += xe - x;
      d += ' H' + xe.toFixed(1);
      st.total = len;
      linea.setAttribute('d', d);
      area.setAttribute('d', d + ' V' + h + ' H' + (X0 * w).toFixed(1) + ' Z');
      inv.setAttribute('x1', (X0 * w).toFixed(1)); inv.setAttribute('x2', xe.toFixed(1));
      inv.setAttribute('y1', (BASE * h).toFixed(1)); inv.setAttribute('y2', (BASE * h).toFixed(1));
      linea.style.strokeDasharray = len.toFixed(1) + ' ' + len.toFixed(1);
      head.style.left = '0'; head.style.top = '0';
      pintar(false);
    }

    function pintar(anima) {
      var fin = st.k >= n;
      var lk = fin ? st.total : st.L[st.k];
      var p = fin ? [XFIN * st.w, st.P[n][1]] : st.P[st.k];
      graf.classList.toggle('is-quieto', !anima);
      linea.style.strokeDashoffset = (st.total - lk).toFixed(1);
      area.style.clipPath = 'inset(0 ' + Math.max(0, st.w - p[0]).toFixed(1) + 'px 0 0)';
      head.style.transform = 'translate(' + p[0].toFixed(1) + 'px,' + p[1].toFixed(1) + 'px)';
    }

    function efecto(cls, txt, p, frames, ms, easing) {
      var el = document.createElement('span');
      el.className = cls;
      if (txt) el.textContent = txt;
      graf.appendChild(el);
      var a = el.animate(frames(p), { duration: ms, easing: easing, fill: 'forwards' });
      a.onfinish = function () { el.remove(); };
      return a;
    }

    function visible() {
      var r = card.getBoundingClientRect();
      return !document.hidden && r.bottom > 0 && r.top < (window.innerHeight || 0);
    }

    function venta() {
      st.timer = 0;
      if (!visible()) { st.timer = setTimeout(venta, 700); return; }
      if (st.k >= n) {
        /* Arriba del todo: se apaga y vuelve a empezar desde cero. */
        graf.classList.add('is-reset');
        st.timer = setTimeout(function () {
          st.k = 0;
          pintar(false);
          requestAnimationFrame(function () { graf.classList.remove('is-reset'); });
          st.timer = setTimeout(venta, 650);
        }, 450);
        return;
      }
      var p = st.P[st.k + 1];
      var tok = toks[st.cuenta++ % toks.length].cloneNode(true);
      tok.removeAttribute('hidden');
      tok.removeAttribute('data-kb-tok');
      graf.appendChild(tok);
      /* Cae con aceleración, como algo que pesa, y se posa con los pies
         sobre el peldaño (pie = centro + 21 px). */
      var pie = p[1] - 21;
      var caida = tok.animate([
        { transform: 'translate(' + p[0] + 'px,' + (pie - 80) + 'px) scale(.8) rotate(-8deg)', opacity: 0 },
        { transform: 'translate(' + p[0] + 'px,' + (pie - 46) + 'px) scale(1) rotate(-4deg)', opacity: 1, offset: 0.35 },
        { transform: 'translate(' + p[0] + 'px,' + pie + 'px) scale(1) rotate(0deg)', opacity: 1 }
      ], { duration: 520, easing: 'cubic-bezier(.55,0,.85,.35)', fill: 'forwards' });
      caida.onfinish = function () {
        /* Un pequeño rebote al posarse y se funde en el peldaño. */
        tok.animate([
          { transform: 'translate(' + p[0] + 'px,' + pie + 'px) scale(1.06, .92)', opacity: 1 },
          { transform: 'translate(' + p[0] + 'px,' + (pie - 4) + 'px) scale(1)', opacity: 1, offset: 0.35 },
          { transform: 'translate(' + p[0] + 'px,' + (pie + 6) + 'px) scale(.55)', opacity: 0 }
        ], { duration: 520, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'forwards' }).onfinish = function () { tok.remove(); };
        st.k += 1;
        pintar(true);
        efecto('kb__ing-ring', '', p, function (q) {
          return [{ transform: 'translate(' + q[0] + 'px,' + q[1] + 'px) scale(.3)', opacity: .9 },
            { transform: 'translate(' + q[0] + 'px,' + q[1] + 'px) scale(2.3)', opacity: 0 }];
        }, 700, 'cubic-bezier(.23,1,.32,1)');
        efecto('kb__ing-plus', '+', p, function (q) {
          return [{ transform: 'translate(' + q[0] + 'px,' + (q[1] - 6) + 'px)', opacity: 1 },
            { transform: 'translate(' + q[0] + 'px,' + (q[1] - 34) + 'px)', opacity: 0 }];
        }, 820, 'cubic-bezier(.23,1,.32,1)');
      };
      st.timer = setTimeout(venta, st.k + 1 >= n ? 3200 : 1150);
    }

    medir();
    if ('ResizeObserver' in window) new ResizeObserver(medir).observe(graf);
    else window.addEventListener('resize', medir);

    /* Si la sección entra armada, la curva espera a la entrada de las
       tarjetas y arranca vacía. Si ya se veía al cargar, arranca entera y
       el bucle la vacía después: nada se vacía delante del usuario. */
    if (root.classList.contains('k3d--armed') && !root.classList.contains('k3d--on')) {
      st.k = 0;
      pintar(false);
      root.addEventListener('k3d:on', function () { if (!st.timer) st.timer = setTimeout(venta, 900); });
    } else {
      st.timer = setTimeout(venta, 2400);
    }
  }

  function mirar() {
    raf = 0;
    var vh = window.innerHeight || 1;
    for (var i = bandas.length - 1; i >= 0; i--) {
      var b = bandas[i];
      if (b.el.getBoundingClientRect().top < vh * 0.78) {
        b.root.classList.add('kb--band-on');
        bandas.splice(i, 1);
      }
    }
  }

  function onScroll() {
    if (!raf && bandas.length) raf = requestAnimationFrame(mirar);
  }

  /* El viaje de cada tarea: desde el escudo del club hasta su sitio. */
  function viajes(root, band) {
    var club = band.querySelector('.kb__club-av');
    if (!club) return;
    var c = club.getBoundingClientRect();
    Array.prototype.forEach.call(band.querySelectorAll('.kb__tareas li'), function (li) {
      var r = li.getBoundingClientRect();
      li.style.setProperty('--viaje', Math.round(c.left + c.width / 2 - (r.left + r.width / 2)) + 'px');
    });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kb]'), function (root) {
      if (!reduce.matches && fine.matches) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-kb-card]'), tarjeta);
      }
      ingresos(root);
      var band = root.querySelector('[data-kb-band]');
      if (!band || reduce.matches || root.getAttribute('data-kb-band-ok')) return;
      root.setAttribute('data-kb-band-ok', '1');
      /* Solo se arma si la banda está entera por debajo de la ventana: lo
         que ya se ve no se vacía delante del usuario. */
      if (band.getBoundingClientRect().top > (window.innerHeight || 0)) {
        viajes(root, band);
        root.classList.add('kb--band-armed');
        bandas.push({ root: root, el: band });
      }
    });
    onScroll();
  }

  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
